const host = `${window.location.hostname}${window.location.port ? `:${window.location.port}` : ""}`

export default {
  host,

  httpBaseUri: "unset",
  httpServiceBaseUri: "unset",
  wsServiceBaseUri: "unset",

  clientBaseUri: "unset",
  clientId: "OperandioWebClient",
  clientKiosk: false,
  clientDevice: false,

  deviceBaseUri: "com.operandio.app://",

  showConfigInTitle: false,

  dataClient: {
    retry: {
      enabled: false,
    },
  },

  auth: {
    idleTimeoutMs: false,
    // idleTimeoutMs: (1000 * 60) * 15, //  15 minutes
    refreshOffset: 1000 * 60 * 3, // 3 minutes
    pinLength: 4,
    device: {
      register: {
        passcodeLength: 10,
      },
    },
  },

  authProviders: {
    external: {
      redirect_uri: `https://${host}/login-result`,
      response_type: "code",
      scope: "openid profile email",
      filterProtocolClaims: true,
      loadUserInfo: true,
    },
    google: {
      authority: "https://accounts.google.com",
      client_id: "829642099593-gpo9pioqi5g1o9k0f01ddsoteilqiamo.apps.googleusercontent.com",
      login_redirect_uri: `https://${host}/google`,
      signup_redirect_uri: `https://${host}/signup/google`,
      post_logout_redirect_uri: `https://${host}/`,
      response_type: "id_token",
      scope: "openid profile email",
      filterProtocolClaims: true,
      loadUserInfo: true,
      prompt: "select_account",
    },
    microsoft: {
      authority: "https://login.microsoftonline.com/234873ad-da2e-4910-9e38-d068b4caba3b/v2.0",
      client_id: "557608e7-1534-45cc-b9ba-d368f7ab49fc",
      login_redirect_uri: `https://${host}/microsoft`,
      signup_redirect_uri: `https://${host}/signup/microsoft`,
      post_logout_redirect_uri: `https://${host}/`,
      response_type: "code",
      scope: "openid profile email",
      filterProtocolClaims: true,
      loadUserInfo: true,
      prompt: "select_account",
    },
  },

  version: {
    check: {
      enabled: true,
      intervalMs: 1000 * 60 * 2, // 2 minutes
      // intervalMs: (2000), // 2 seconds, for testing
    },
  },

  polling: {
    jobsMs: 15000,
  },

  theme: {
    logoContainer: "unset",
  },

  uploader: {
    acceptImages: [".png", ".jpg", ".jpeg"],
    acceptDocuments: [
      ".pdf",
      ".doc",
      ".docx",
      ".odt",
      ".pages",
      ".xls",
      ".xlsx",
      ".xlt",
      ".xltx",
      ".ods",
      ".ots",
      ".zip",
      ".gz",
      ".xz",
    ],

    imageViewerBaseUri: "unset",
    imageViewerBucketName: "unset",
  },

  templates: {
    featuredCategory: "5f7d4d9c5d6817e2fb4438ba",
  },

  links: {
    terms: "https://operandio.com/terms",
    privacy: "https://operandio.com/privacy-policy",
    help: "https://help.operandio.com",
    emailSupport: "support@operandio.zendesk.com",
    kiosk: {
      login: "operandio://kiosk/login-kiosk",
      logout: "operandio://kiosk/login-kiosk",
    },
    device: {
      login: "operandio://device/login-device",
      logout: "operandio://device/logout-device",
      reauth: "operandio://device/reauth-device",
    },
  },

  stripe: {
    publishableKey:
      "pk_test_51GxNIsCmvyAu99J0zSm3s4WkoLqlUVQivMB7NC2mNLHStEivCR56Zw6E64KmUIKY3WgHbxctV3mCdPIgYpdosUpJ00cIRCMU4A",
  },

  announceKit: {
    widget: "https://announcekit.co/widgets/v2/3PpfUI",
  },

  services: {
    localisationUrl: "https://services.operandio.com/localisation",
    export: {
      jobUrl: "https://nig1o9pqw8.execute-api.ap-southeast-2.amazonaws.com/prod/", // LIVE account
    },
  },

  google: {
    mapsApiKey: "AIzaSyBI3STyewxhrfNJcP1hfJbyol59Y5oynTk",
  },

  support: {
    userflow: {
      enabled: true,
      token: "ct_s3dnceed5nenvkvwnxs67qoeum",
    },
  },

  sensors: {
    battery: {
      warnLowPercent: 10,
    },
    at: {
      warnAgoMaxMin: 45,
    },
  },

  errors: {
    showDetail: false,
    showGraphQLErrorNotification: false,
  },
}
